// NotificationContext.js
import React, { createContext, useContext } from 'react';
import { notification } from 'antd';

// Create context with default value of null
const NotificationContext = createContext(null);

// Create a provider for the context
export const NotificationProvider = ({ children }) => {
  // Function to trigger a notification
  const notify = ({ type, message, description, duration = 4, placement = 'topRight' }) => {
    notification[type]({
      message,
      description,
      duration,
      placement,
    });
  };

  return (
    <NotificationContext.Provider value={notify}>
      {children}
    </NotificationContext.Provider>
  );
};

// Custom hook to use notifications in any component
export const useNotification = () => {
  const notify = useContext(NotificationContext);
  if (!notify) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }
  return notify;
};
